import { useEffect, useRef } from "react";
import {
  selectTabTitleUpdateIntervalId,
  selectDefaultTabTitle,
  selectChatSettings,
} from "../../../modules/chat/selectors";
import { useAppSelector, useAppDispatch } from "../../../hooks";
import { setTabTitleUpdateIntervalId } from "../../../modules/chat/actions";
import { isChatOpen } from "../../../modules/control/predicates";
import { useControlContext } from "../../../modules/control";

export const useShowMessageCount = () => {
  const { unreadCount } = useAppSelector(selectChatSettings);
  const intervalId = useAppSelector(selectTabTitleUpdateIntervalId);
  const defaultTabTitle = useAppSelector(selectDefaultTabTitle);
  const dispatch = useAppDispatch();
  const { chatState } = useControlContext();
  const isOpenChat = isChatOpen(chatState);

  const pollingInterval = useRef<number | null>(null);

  if (unreadCount && intervalId) {
    clearInterval(intervalId);
    dispatch(setTabTitleUpdateIntervalId(null));
    document.title = defaultTabTitle;
  }

  useEffect(() => {
    if (pollingInterval.current) {
      clearInterval(pollingInterval.current);
      document.title = defaultTabTitle;
    }

    if (!isOpenChat && unreadCount) {
      pollingInterval.current = window.setInterval(() => {
        document.title =
          document.title === defaultTabTitle
            ? getMessageText(unreadCount)
            : defaultTabTitle;
      }, 1000);
    }
  }, [unreadCount]);
};

const getMessageText = (count: number): string => {
  if (count % 10 === 1 && count % 100 !== 11) {
    return `${count} новое сообщение`;
  }

  if (
    count % 10 >= 2 &&
    count % 10 <= 4 &&
    (count % 100 < 12 || count % 100 > 14)
  ) {
    return `${count} новых сообщения`;
  }

  return `${count} новых сообщений`;
};
